import React from "react";
import {
    Facebook,
    Instagram,
    Linkedin,
    Youtube,
} from "lucide-react";
import { RiArrowDropLeftFill, RiArrowDropRightFill } from "react-icons/ri";
import { BsTwitterX } from "react-icons/bs";

const Footer = () => {
    return (
        <footer className="bg-[#F5F7FB] text-[#012D6F] py-10 px-6 md:px-16">
            {/* Top line with arrows */}
            <div className="flex items-center justify-center relative mb-10">
                <div className="absolute -left-3 flex items-center">
                    <RiArrowDropLeftFill className="w-6 h-6 text-[#012D6F]" />
                </div>
                <div className="absolute -right-3 flex items-center">
                    <RiArrowDropRightFill className="w-6 h-6 text-[#012D6F]" />
                </div>
                <div className="h-[2px] bg-[#012D6F] w-full"></div>
            </div>

            {/* Footer Content */}
            <div className="flex flex-col lg:flex-row justify-between items-center gap-10 lg:items-start">
                {/* Left Side */}
                <div className="lg:w-1/3 text-sm leading-relaxed text-center lg:text-left">
                    <p className="mb-4">
                        4 Aviators’ policy is to ensure that every student pilot is trained
                        and certified to operate safely and independently in accordance with
                        SACAA standards before advancing to solo or commercial operations.
                    </p>
                    <p className="text-xs mb-4">
                        © 4 AVIATORS FLIGHT SCHOOL (PTY) LTD | REGISTERED IN SOUTH AFRICA
                        <br />
                        HANGAR 3, RAND AIRPORT, GERMISTON, GAUTENG, SOUTH AFRICA, 1401
                        <br />
                        COMPANY REG. NO. 2023/123456/07
                    </p>
                    <div className="flex justify-center lg:justify-start gap-4 text-xs">
                        <a href="#" className="hover:text-[#E43038] transition">
                            Privacy
                        </a>
                        <a href="#" className="hover:text-[#E43038] transition">
                            Terms & Condition
                        </a>
                    </div>
                </div>

                {/* Center Logo */}
                <div className="flex justify-center items-center">
                    <img
                        src="https://mhcockpit.com/Media/4%20Aviators/Logo/4_Aviators_Logo.png"
                        alt="4 Aviators Logo"
                        className="w-48 md:w-56 object-contain"
                    />
                </div>

                {/* Right Side */}
                <div className="lg:w-1/3 text-center lg:text-right">
                    <div className="mb-6">
                        <h4 className="font-semibold text-lg mb-3">Quick Links</h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <a href="/training" className="hover:text-[#E43038] transition">
                                    Training
                                </a>
                            </li>
                            <li>
                                <a href="/our-fleet" className="hover:text-[#E43038] transition">
                                    Our Fleet
                                </a>
                            </li>
                            <li>
                                <a href="/about-us" className="hover:text-[#E43038] transition">
                                    About Us
                                </a>
                            </li>
                            <li>
                                <a href="/contact-us" className="hover:text-[#E43038] transition">
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold text-lg mb-3">Connect with Us</h4>
                        <div className="flex justify-center lg:justify-end gap-4">
                            <a href="#" className="hover:text-[#E43038] transition">
                                <Instagram className="w-5 h-5" />
                            </a>
                            <a href="#" className="hover:text-[#E43038] transition">
                                <Youtube className="w-5 h-5" />
                            </a>
                            <a href="#" className="hover:text-[#E43038] transition">
                                <Linkedin className="w-5 h-5" />
                            </a>
                            <a href="#" className="hover:text-[#E43038] transition">
                                <Facebook className="w-5 h-5" />
                            </a>
                            <a href="#" className="hover:text-[#E43038] transition">
                                <BsTwitterX className="w-5 h-5" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom border line */}
            <div className="mt-10 border-t border-[#012D6F]/30 pt-4 text-center text-xs text-[#012D6F]/80">
                Designed & Developed by MH Cockpit
            </div>
        </footer>
    );
};

export default Footer;
